import React from 'react';
import { formatPrice } from '@/domains/mobile-web/utils/price';

export interface BookInfoItem {
  name?: string;
  title?: string;
  qty?: number;
  price: number;
}

interface BookInfoProps {
  listBookInfo: BookInfoItem[];
}

const BookInfo = ({ listBookInfo }: BookInfoProps) => {
  return (
    <>
      {listBookInfo.map((book, index) => (
        <div
          key={index}
          className="w-full inline-flex  gap-3 flex-wrap items-center bg-bg-grey-200 border-blue-cs-200 border p-3 rounded-[12px] justify-between "
        >
          <div className="inline-flex flex-wrap gap-3 items-start lg:items-center flex-1 basis-[400px] ">
            <p className="shadowCard bg-black p-1 text-white border-transparent title1medium rounded-[12px] min-w-[40px] text-center">
              {index + 1}
            </p>
            <div className="w-fit">
              <p className="   body1medium">{book.title}</p>
              <p className=" text-text-grey   body1medium">{book.name}</p>
            </div>
          </div>
          <div className="w-fit  flex flex-row flex-wrap gap-3 ">
            <div className="w-fit">
              <p className="body2 text-text-grey">JUMLAH (QTY)</p>
              <p className="title2bold">{book.qty} Buku</p>
            </div>
            <div className="w-fit">
              <p className="body2 text-text-grey">SUBTOTAL</p>
              <p className="title2bold">Rp. {formatPrice(book.price)}</p>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default BookInfo;
